import { Mapper } from "../../../../base/utils/mapper";
import { MetodoPagoSaludModel } from "../../../../domain/models/configuration/metodo-pago-salud.model";
import { MetodoPagoSaludEntity } from "../entities/metodo-pago-salud.entity";


export class MetodoPagoSaludImplementationRepositoryMapper extends Mapper<MetodoPagoSaludEntity, MetodoPagoSaludModel> {
	mapFrom(param: MetodoPagoSaludEntity): MetodoPagoSaludModel {
		return {
			data:param.data,
			isSuccess:param.isSuccess,
			message:param.message,
			errors:param.errors
		};
	}
	mapTo(param: MetodoPagoSaludModel): MetodoPagoSaludEntity {
		return {
			data:param.data,
			isSuccess:param.isSuccess,
			message:param.message,
			errors:param.errors
		}
	}
}